import { render } from "./right-panels.vue?vue&type=template&id=256a894a"
import script from "./right-panels.vue?vue&type=script&lang=js"
export * from "./right-panels.vue?vue&type=script&lang=js"

import "./right-panels.vue?vue&type=style&index=0&id=256a894a&lang=css"

import exportComponent from "F:\\workspace\\pros\\ydxc-station\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__